import React, { useState, useEffect } from 'react';
import { LeaderboardTabsList, LeaderboardType } from '../../types/leaderboard';
import LeaderboardHighlights from './LeaderboardHighlights';
import LeaderboardTabs from './LeaderboardTabs';
import BadgeAchievementLeaderboard from '../BadgeAchievement/BadgeAchievement';
import './LeaderboardContainer.css';
import EmailReporting from '../EmailReporting/EmailReporting';
import TrainingCompletionLeaderboard from '../TrainingCompletion/TrainingCompletion';
import ChangeWorkSpace from '../../hoc/changeWorkSpace';
import { getCurrentCellStore } from '../../utils/util';
import { IWorkSpaceData } from '../../redux/workSpaceSlice';
import { LEADERBOARD_TABS } from '../../constants/constants';

const LeaderboardContainerComponent: React.FC<{ cellId: number }> = ({ cellId }) => {
  const [active, setActiveTab] = useState<LeaderboardType | null>(null);
  const userCurrentCellStore = getCurrentCellStore();

  useEffect(() => {
    const defaultPageActive = getTabsByCondition(tabs, userCurrentCellStore);
    if (defaultPageActive && defaultPageActive.length > 0) {
      setActiveTab(defaultPageActive[0].type as LeaderboardType);
    }
  }, [cellId]);

  const renderLeaderboard = () => {
    switch (active) {
      case LeaderboardType.EMAIL_REPORTING:
        return (
          <EmailReporting
            cellId={cellId}
            isAttribute={userCurrentCellStore?.show_attribute_email_reporting}
          />
        );
      case LeaderboardType.COURSE_COMPLETION:
        return (
          <TrainingCompletionLeaderboard
            cellId={cellId}
            isAttribute={userCurrentCellStore?.show_attribute_training_completion}
          />
        );
      case LeaderboardType.ACHIEVEMENT_COMPLETION:
        return (
          <BadgeAchievementLeaderboard
            cellId={cellId}
            isAttribute={userCurrentCellStore?.show_attribute_achievement_completion}
          />
        );
      default:
        return null;
    }
  };

  const tabs: LeaderboardTabsList[] = [
    {
      type: LeaderboardType.EMAIL_REPORTING,
      label: LEADERBOARD_TABS.EMAIL_REPORTING
    },
    {
      type: LeaderboardType.COURSE_COMPLETION,
      label: LEADERBOARD_TABS.COURSE_COMPLETION
    },
    {
      type: LeaderboardType.ACHIEVEMENT_COMPLETION,
      label: LEADERBOARD_TABS.ACHIEVEMENT_COMPLETION
    }
  ];
  
  const getTabsByCondition = (tabs: LeaderboardTabsList[], workSpace?: IWorkSpaceData) =>
    tabs.filter(
      (item) =>
        (workSpace?.show_email_reporting_data && item.type === LeaderboardType.EMAIL_REPORTING) ||
        (workSpace?.show_training_completion_data &&
          item.type === LeaderboardType.COURSE_COMPLETION) ||
        (workSpace?.show_achievement_collection_data &&
          item.type === LeaderboardType.ACHIEVEMENT_COMPLETION)
    );

  return (
    active && (
      <>
        <div className="leaderboard-title">{LEADERBOARD_TABS[active]}</div>
        <div className="leaderboard-container">
          <LeaderboardHighlights activeTab={active} />
          <LeaderboardTabs
            tabs={getTabsByCondition(tabs, userCurrentCellStore)}
            activeTab={active}
            onTabChange={setActiveTab}
          />

          <div className="leaderboard-content">{renderLeaderboard()}</div>
        </div>
      </>
    )
  );
};
export const LeaderboardContainer = ChangeWorkSpace(LeaderboardContainerComponent);
